export default __webpack_public_path__ + "static/media/promo-detail-carbonTime.f02e7c00.svg";